function areArraysEqual(arr1: Array<string>, arr2: Array<string>): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((element, index) => {
    return element === arr2[index];
  });
}

export { areArraysEqual };
